import type { IButtonProps } from '@fluentui/react/lib/Button';
import { observer } from 'mobx-react-lite';
import CalendarBar from 'owa-calendar-forms-common/lib/components/CalendarBar';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { openItemButtonAriaLabel } from 'owa-locstrings/lib/strings/openitembuttonarialabel.locstring.json';
import * as React from 'react';

export interface QuickComposeHeaderProps {
    colorScheme: ColorScheme;
    onLaunchFullComposeCallback: () => void;
    className?: string;
}

export default observer(function QuickComposeHeader(props: QuickComposeHeaderProps) {
    const { colorScheme, onLaunchFullComposeCallback, className } = props;
    const buttonProps: IButtonProps = {
        onClick: onLaunchFullComposeCallback,
        iconProps: {
            iconName: ControlIcons.FullScreen,
            styles: {
                root: {
                    fontSize: '15px',
                    color: colorScheme.accessibleText.calPrimaryBackground,
                },
            },
        },
        title: loc(openItemButtonAriaLabel),
        ariaLabel: loc(openItemButtonAriaLabel),
    };
    return (
        <CalendarBar
            className={className}
            calendarColorScheme={colorScheme}
            buttonProps={[buttonProps]}
        />
    );
});
